import React, {Component} from "react";
import {connect} from "react-redux";
import MenuSection from "./menu-section";

class MegaMenu extends Component {
  constructor(props){
    super(props);
    this.hasChildInMenu = this.hasChildInMenu.bind(this);
  }

  hasChildInMenu() {
    const properResult = this.props.navigation.mainNavigation.filter( (menuItem) =>  {
      return Object.prototype.hasOwnProperty.call(menuItem,'subMenuItems');
    });
    return ( (properResult &&  properResult.length > 0 ) ? true : false );
}

  render() {
    let visibility = {
      display: (this.props.visible && this.hasChildInMenu() ) ? "block" : "none"
    };

    return (
      <div style={visibility} className="mega-menu">
        <div className="row no-gutter">
          {this.props.navigation.mainNavigation.map(value => {
            if (value.showMegaMenu) {
              return <MenuSection menuItem={value} key={value.id} />;
            }
            return null;
          })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    navigation: state.navigation
  };
}

export default connect(mapStateToProps)(MegaMenu);
